import React, { useState } from "react";
import { motion } from "framer-motion";
import "./Gallery.css";

export default function Gallery() {
const allImages = [
  "https://i.pinimg.com/736x/ae/b4/f7/aeb4f746a4a652833d359de70459945b.jpg",
  "https://jooinn.com/images/beautiful-house-1.jpg",
  "https://media.istockphoto.com/id/472018064/photo/beautiful-new-england-style-home-exterior-at-night.jpg?s=612x612&w=0&k=20&c=aJvgIBQv7iJQy2xKrAkK_vXjPcW8n4ufsEsmVJyC8Eg=",
  "https://media.istockphoto.com/id/2155879397/photo/house-in-a-charming-neighborhood-with-stunning-sidewalk-landscaping.jpg?s=612x612&w=0&k=20&c=nQJOUoNb2RNev3QVNjIohcmxQABCTetCdgfnc8MV8sU=",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxlwTDprZH9hNlbKjuW0wqFQkVsYstNQ9hsg&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZUtSLG_gCOUy24fQzlVUWP94y23xuHIZkKA&s",
  "https://plus.unsplash.com/premium_photo-1661883982941-50af7720a6ff?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8YmVhdXRpZnVsJTIwaG91c2V8ZW58MHx8MHx8fDA%3D",
];


  const [visibleCount, setVisibleCount] = useState(8);

  return (
    <section className="gallery" id="gallery">
      <motion.h2
        className="gallery-title"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Latest <span>Projects</span>
      </motion.h2>

      <div className="gallery-masonry">
        {allImages.slice(0, visibleCount).map((src, index) => (
          <motion.div
            className="gallery-card"
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.05 }}
          >
            <img src={src} alt="Project" />
            <div className="gallery-glass">
              <span>Project {index + 1}</span>
            </div>
          </motion.div>
        ))}
      </div>

      {visibleCount < allImages.length && (
        <div className="gallery-btn-wrapper">
          <button
            className="gallery-btn"
            onClick={() => setVisibleCount(allImages.length)}
          >
            Load More Projects
          </button>
        </div>
      )}
    </section>
  );
}
